module.exports = __webpack_public_path__ + "img/user.79d0c6a7.svg";